module.exports = __webpack_public_path__ + "static/media/Lato-Bold.cccb8974.woff2";